import { render, staticRenderFns } from "./KYCPage.vue?vue&type=template&id=344463d9&"
import script from "./KYCPage.vue?vue&type=script&lang=js&"
export * from "./KYCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports